// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:2ed93f2a-cea0-4664-bc5f-febf7f56f557",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_ZIOTdkRsi",
    "aws_user_pools_web_client_id": "1c3o8etrtk4fnr184enr083p7e",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://z5gnqscwkzf2rjf4emnjp345eu.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_content_delivery_bucket": "rkbchirashivisioncms-20200311141544-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "http://rkbchirashivisioncms-20200311141544-hostingbucket-prod.s3-website-ap-northeast-1.amazonaws.com",
    "aws_user_files_s3_bucket": "rkbchirashivisioncms183be39efba749b0be74a11af5d153518-prod",
    "aws_user_files_s3_bucket_region": "ap-northeast-1"
};


export default awsmobile;
